// extracted by mini-css-extract-plugin
module.exports = {"cursor":"Cursor-module--cursor--2fIkL","active":"Cursor-module--active--O6D4E"};